import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';

import makeStyles from '@mui/styles/makeStyles';

import EditItemView from '../common/components/EditItemView';
import { useTranslation } from '../common/components/LocalizationProvider';
import { getWithExpiry } from '../common/util/localstorage';

import { useDispatch, useSelector } from 'react-redux';
import { clientsActions, productsActions } from '../store';
import Autocomplete from '@mui/material/Autocomplete';

const useStyles = makeStyles((theme) => ({
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },

  clientForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #ccc',
    borderRadius: 4,
    marginTop: theme.spacing(2),
  },
}));


const ProductPage = () => {

  const classes = useStyles();
  const t = useTranslation();

  const dispatch = useDispatch();


  const [item, setItem] = useState();

  const [showClientForm, setShowClientForm] = useState(false);


  const [newClient, setNewClient] = useState({
    username: '',
    email: '',
    phone: '',
    adresse: '',
  });


  // Clients loaded from login
  const _clients = useSelector(
    (state) => state.clients.items || []
  );


  const validate = () =>
    item &&
    item.reference &&
    item.designation &&
    item.marque &&
    item.model &&
    item.type &&
    item.client;



  const handleCreateClient = async () => {

    try {

      const res = await fetch(
        `${process.env.REACT_APP_URL_NAME}/clients`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',

            Authorization:
              `Bearer ${getWithExpiry('TOKEN')}`,
          },

          body: JSON.stringify(newClient),
        }
      );


      if (res.ok) {


        const createdClient = await res.json();


        // Update Redux clients list
        dispatch(
          clientsActions.setItems([
            ..._clients,
            createdClient,
          ])
        );


        // Select new client automatically
        setItem({
          ...item,
          client: createdClient._id,
        });



        setNewClient({
          username: '',
          email: '',
          phone: '',
          adresse: '',
        });


        setShowClientForm(false);


      } else {

        console.error(await res.text());

      }


    } catch (err) {

      console.error(err);

    }

  };



  return (

    <EditItemView
      endpoint="products"
      item={item}
      setItem={setItem}
      validate={validate}
       
    >


      {item && (

        <Accordion defaultExpanded>


          <AccordionSummary expandIcon={<ExpandMoreIcon />}>

            <Typography variant="subtitle1">
              {t('sharedRequired')}
            </Typography>

          </AccordionSummary>



          <AccordionDetails className={classes.details}>


            <TextField
              label="Référence"
              value={item.reference || ''}
              onChange={(e) =>
                setItem({
                  ...item,
                  reference:e.target.value
                })
              }
            />


            <TextField
              label="Désignation"
              value={item.designation || ''}
              onChange={(e) =>
                setItem({
                  ...item,
                  designation:e.target.value
                })
              }
            />



            <TextField
              label="Marque"
              value={item.marque || ''}
              onChange={(e) =>
                setItem({
                  ...item,
                  marque:e.target.value
                })
              }
            />



            <TextField
              label="Modèle"
              value={item.model || ''}
              onChange={(e) =>
                setItem({
                  ...item,
                  model:e.target.value
                })
              }
            />



            <TextField
              select
              label="Type de maintenance"
              value={item.type || ''}
              onChange={(e)=>
                setItem({
                  ...item,
                  type:e.target.value
                })
              }
            >

              {[
                'Vente',
                'Électronique',
                'Mécanique',
                'Électro-Mécanique',
                'Électrique',
                'Hydraulique',
                'Pneumatique',
                'Carrosserie',
                'Peinture',
                'Diagnostic électronique',
                'Entretien général',

              ].map(option=>(

                <MenuItem
                  key={option}
                  value={option}
                >
                  {option}
                </MenuItem>

              ))}


            </TextField>



            <TextField
              select
              label="Statut"
              value={item.statut || 'en attente'}

              onChange={(e)=>
                setItem({
                  ...item,
                  statut:e.target.value
                })
              }
            >

              {[
                'en attente',
                'partiel',
                'livré',
                'retour',
                'annuler'

              ].map(status=>(

                <MenuItem
                  key={status}
                  value={status}
                >

                  {
                    status.charAt(0).toUpperCase()
                    +
                    status.slice(1)
                  }

                </MenuItem>

              ))}


            </TextField>




            <TextField
              label="Commentaire"

              value={item.commentaire || ''}

              onChange={(e)=>
                setItem({
                  ...item,
                  commentaire:e.target.value
                })
              }

            />





            {/* Client */}

            <Box
              display="flex"
              alignItems="center"
              gap={1}
            >


        <Autocomplete

  options={_clients}

  value={
    _clients.find(
      (client) =>
        client._id ===
        (item.client?._id || item.client)
    ) || null
  }


  getOptionLabel={(client) =>
    client
      ? `${client.username || ''}${
          client.phone
            ? ` - ${client.phone}`
            : ''
        }`
      : ''
  }


  onChange={(event, newClient) => {

    setItem({
      ...item,
      client: newClient
        ? newClient._id
        : ''
    });

  }}


  isOptionEqualToValue={(option, value) =>
    option._id === value._id
  }


  renderOption={(props, client) => (

    <Box
      component="li"
      {...props}
      key={client._id}
      sx={{
        display:"flex",
        flexDirection:"column",
        alignItems:"flex-start"
      }}
    >

      <Typography
        fontWeight={600}
      >
        {client.username}
      </Typography>


      <Typography
        variant="body2"
        color="text.secondary"
      >

        {client.email || "-"}
        {" | "}
        {client.phone || "-"}

      </Typography>


    </Box>

  )}



  renderInput={(params) => (

    <TextField

      {...params}

      label="Client"

      placeholder="Rechercher un client..."

    />

  )}


  sx={{
    flex:1
  }}

/>



              <IconButton
                onClick={() =>
                  setShowClientForm(
                    !showClientForm
                  )
                }

                size="large"
              >

                <AddIcon/>

              </IconButton>


            </Box>






            {
              showClientForm && (


                <Box className={classes.clientForm}>


                  <Typography variant="subtitle2">
                    Créer un nouveau client
                  </Typography>



                  <TextField
                    label="Nom"

                    value={newClient.username}

                    onChange={(e)=>
                      setNewClient({
                        ...newClient,
                        username:e.target.value
                      })
                    }

                  />



                  <TextField
                    label="Email"

                    value={newClient.email}

                    onChange={(e)=>
                      setNewClient({
                        ...newClient,
                        email:e.target.value
                      })
                    }

                  />



                  <TextField
                    label="Téléphone"

                    value={newClient.phone}

                    onChange={(e)=>
                      setNewClient({
                        ...newClient,
                        phone:e.target.value
                      })
                    }

                  />



                  <TextField
                    label="Adresse"

                    value={newClient.adresse}

                    onChange={(e)=>
                      setNewClient({
                        ...newClient,
                        adresse:e.target.value
                      })
                    }

                  />



                  <Box mt={1}>

                    <IconButton
                      color="primary"
                      onClick={handleCreateClient}
                    >

                      <AddIcon/>

                    </IconButton>


                  </Box>



                </Box>


              )
            }



          </AccordionDetails>


        </Accordion>

      )}


    </EditItemView>

  );

};


export default ProductPage;